module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kj-Lb.a1419020.png";